import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { useNavigate } from 'react-router';
import 'bootstrap/dist/css/bootstrap.min.css';

import { accountService } from '@/_services/account.service';
import { axiosService } from '@/_services/account.axios';
import TitreH2 from '@/components/UI/titres/TitreH2';
import './mail.css';

const Mailing = () => {

  let span = document.getElementById("message");  //pour affichage messages d'anomalie

  const navigate= useNavigate();
  //init variables
  //mailinfo varaible text du mail pour axios
  const [mailInfo,setMailInfo]= useState({
    idListeDiffusion: '',
    sujet: '',
    entete: '',
    signature: '',
  });

  //container fichiers joints
  const fichiersJoints = useRef([]);

  //ref pour l'editeur
  const editorRef = useRef(null);

  //Flag pour l'affichage synchro axios
  const [flagMail,setFlagMail] = useState('mail');

  //récupération de la signature et des listes de diffusion
  const flag= useRef(false); //pour synchro axios
  const listesDiffusion= useRef('');

  useEffect(() => {
    if(flag.current === false){
      const options= {
        values:{
          domaine:'mail',
          action: 'getDataMail',
          email: accountService.getEmailUser(),  
        },
        OKData: (data) => {
          listesDiffusion.current= data.listesDiffusion;
          setMailInfo({signature: data.signature})
        }
      }
      axiosService.postAxios(options);
    }
 
  }, [])

const handleChange= (e)=>{
    setMailInfo({...mailInfo,[e.target.name]: e.target.value})
    span && span.firstChild && span.firstChild.remove(); //supprimer l'ancien message d'anomalie
  }

    
  const onSubmit= (e)=>{
    e.preventDefault();
    
     //controles
    let textAno='';
    if(!mailInfo.idListeDiffusion ){
      textAno+= 'Liste de diffusion obligatoire ';
    }
    if(!mailInfo.sujet){
      textAno+= 'Sujet obligatoire ';
    }
    if(!mailInfo.entete){
      textAno+= 'En tête obligatoire ';
    }
    if(editorRef.current.getContent()===''){
      textAno+= ' Absence de contenu '
    }
    let txt = document.createTextNode(textAno);
    span.appendChild(txt);

    //Si pas d'ano envoi mail
    if(textAno===''){
      setFlagMail('wait');
      let corpsMessage= mailInfo.entete !== 'NA'?mailInfo.entete +editorRef.current.getContent()
                                                :editorRef.current.getContent();

      const options={
        values:{
          domaine: 'mail',
          action: 'envoiMail',
          mode: 'differe',
          sujet: mailInfo.sujet,
          idListeDiffusion: mailInfo.idListeDiffusion,
          corpsMessage: corpsMessage,
          emailEmetteur: accountService.getEmailUser(),
          fichiersJoints: fichiersJoints.current
        },
        OKData: (data)=>{
          setFlagMail('AR')
        },
        ErrorData: (data)=>{
          setFlagMail('AR');
          console.log(data)
        }
      }

      axiosService.postAxios(options);

    }
  };

  fichiersJoints.current=[];    //variable des fichiers joints pour attachement dans mail
  let textFich=''

  // Ajout de fichiers dans tableau
  const fileChange= ()=>{
    const fichiers= document.getElementById('fichiersJoints').files;
    const listeFich= document.getElementById('listePiecesJointes')

    //suppression message ano
    ///const divAno= document.getElementById('anoFich');
    if(document.getElementById('anoFich')) document.getElementById('anoFich').remove();

    //Ajout nouveau fichiers dans liste
    for( const fichier of fichiers) {
      //vérification nom de fichier 
      const regex= /^[a-zA-Z0-9][A-Za-z0-9 _]*\.[a-zA-Z]{3,4}$/;
      if(regex.test(fichier.name)){
        fichiersJoints.current.push(fichier);
        textFich= '<p><strong>' + fichier.name +'</strong></p>';
        listeFich.insertAdjacentHTML('afterbegin',textFich)
  
      }
      else{
        let anoFich= '<p id="anoFich" style="color:red" ><strong>' + fichier.name + '<br/>Nom de fichier non conforme. Renommez votre fichier et recomencez</strong>';
        anoFich+= '<br/><span style="color:red; font-style: italic;">(caractères autorisés : alphanumériques sans acents, espace et _ )</span></p>'
        listeFich.insertAdjacentHTML('beforebegin',anoFich)
      }
      }   
      console.log(fichiersJoints.current)
  }

  //Suppression liste pièces jointes
  const removeListe= (e)=>{

    //suppression message ano
    const divAno= document.getElementById('anoFich');
    if(divAno!==null) document.getElementById('anoFich)').remove();

    let listeFich= document.getElementById('listePiecesJointes')
    fichiersJoints.current= [];
    //RAZ ancienne liste
    console.log(listeFich.firstElementChild)

    while (listeFich.firstElementChild){
      console.log(listeFich.firstElementChild)
      listeFich.removeChild(listeFich.firstElementChild);
    }
    e.preventDefault()
  }
  
  return (

    <>
    {
      flagMail === 'mail' &&
        <>
        <TitreH2 titre= 'Envoyer un mail'/>

        <form  data-form-type="other" encType='multipart/formdata'>
            <div className='mb-2'>
                <h3 className='col-10 offset-2 text-danger ms-1' id='message' name='message'></h3>
            </div>

            <div className='row lh-1' >
              <label for='sujet' className="col-1 ms-5" value={mailInfo.sujet}>Sujet</label>
              <input id='sujet' name='sujet' className='col-4' onChange={(e)=> handleChange(e)}/>
              <label htmlFor='liste' className='col-1 ms-3'>Liste de diffusion</label>            
              <select name='idListeDiffusion' id='idListeDiffusion' className='col-2' onChange={(e)=> handleChange(e)} >
                  <option></option>
                  {
                    Object.values(listesDiffusion.current).map((liste)=>(
                      liste.idListe!== 3 &&
                      <option value={liste.idListe}>{liste.libelleListe}</option>
                    ))
                  }
              </select>
              <label for='entete'  className='col-1 ms-3'>Formule politesse</label>
                <select name='entete' id='entete' className='col-2' onChange={(e)=> handleChange(e)} >
                  <option></option>
                  <option value='NA'>Pas de formule</option>
                  <option value='Bonjour %prenom% %nom%'>Bonjour jean Dupont</option>
                  <option value='Bonjour %prenom%'>Bonjour Jean</option>
                </select>        
            </div>
            

            <div className="row">
              <h4 className='col-6 offset-1 text-center mt-5'>Texte du message</h4>
              <h4 className='col-5 text-center mt-5'>Pièces jointes</h4>
            </div>
            <div className='row'          >
              <div className="col-6 offset-1  text-center">
                  <Editor
                      apiKey='barvl4zof939ubm0yyk1a6aizgfjvx5lfdel5dc7ode3vwrx'
                      onInit={(evt, editor) => editorRef.current = editor}
                      initialValue=" "
                      init={{
                      height: 400,
                      // width: 800,
                      menubar: false,
                      branding: false,
                      statusbar: false,
                      plugins: [
                          'lists advlist autolink link image charmap print preview anchor',
                          'searchreplace visualblocks code fullscreen',
                          'insertdatetime media table paste code help wordcount'
                      ],
                      toolbar: 'undo redo | formatselect | ' +
                      'bold italic backcolor | alignleft aligncenter ' +
                      'alignright alignjustify | bullist numlist outdent indent | ' +
                      'removeformat | insertfile',
                      content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                      }}
                  />
              </div>
              <div className='col-5 '>
                  <div className='row '>
                    <h5><label className='col-5 ' for='fichiersJoints'>Ajouter une pièce jointe</label></h5>
                    <input className='col-7 ' type='file' id='fichiersJoints' accept='.pdf,images/*' name='fichiersJoints[]' multiple='multiple' 
                      onChange={(e)=> fileChange(e)}
                    />
                  </div>
                  <div className='row mt-5 col-10 border border-dark' id='listePiecesJointes'></div>
                  <h5 className='mt-5'>Supprimer les pièces jointes</h5>
                  <button className='button col-2 ' onClick={(e)=>removeListe(e)}>Supprimer</button>
              </div>
            </div>
            <div className="row" >
                      <button type="submit" className="button col-2 offset-1 mt-3" onClick={onSubmit}>Envoyez</button>
            </div>
        </form>
        </>
    }
    {
      flagMail=== 'wait' &&
      <div className='col-10 offset-6 ' style={{color: '#5f56c5'}}>
        <i class="fa fa-cog fa-spin fa-2x fa-fw"></i>
        <h4>Envoi en cours</h4>
      </div>
    }
    {
      flagMail=== 'AR' &&
      <div className='message'>
        <h3>Votre message a été placé en file d'attente</h3>
        <em>Il sera envoyé dans l'heure qui suit</em><br/>
        <button style={{marginTop: '15px'}} onClick={()=>navigate('/messagerie')}>{'Retour à la messagerie'}</button>
      </div>
    }
    </>
  )
};

export default Mailing;